/**
 * Dependencies
 */
import http from '../../../services/HttpService'

/**
 * Check to verify if a given key is valid for a shared project link
 *
 * @return {Promise}
 */
const checkSharedProjectKey = ({ commit, rootState }) => {
    let key = rootState.route.params.projectKey
    commit('KEY_VALIDATION_LOADING')
    return http.get(`auth/${key}/`)
        .then(res => {
            commit('KEY_VALIDATION_SUCCESS', res.data)
            return Promise.resolve(res.data)
        })
        .catch(err => {
            commit('KEY_VALIDATION_FAILURE')
            return Promise.reject(err)
        })
}

/**
 * Attempt to validate a PIN
 *
 * @param  {Object} options.rootState
 * @param  {Object} form
 * @return {Promise}
 */
const accessProject = ({ rootState }, form = {}) => {
    return http.post(`auth/${rootState.route.params.projectKey}/`, form)
}

export default {
    accessProject,
    checkSharedProjectKey
}



// WEBPACK FOOTER //
// ./src/state/modules/shared/actions.js